var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home"},[_c('HomeLanding'),_c('ProjectsSection',{attrs:{"id":"Projects"}}),_c('AboutSection',{attrs:{"id":"About"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }